import { isMultipleSelect, isNumberRange, isObj, isSingleSelect, isTimeRage, isFuzzyMatchSelect } from './fieldType'

// 获取排序展示文案
export const getSortDisplayValue = ({ fields, value }: any) => {
    const fieldOption = fields.find(v => v.name === value?.name)
    const fieldValueOption = fieldOption?.options?.find(v => v.value === value?.value)
    return fieldOption && fieldValueOption ? `${fieldOption.label}-${fieldValueOption.label}` : ''
}

// 默认获取展示值的方法
// eslint-disable-next-line complexity
export default ({ field, value, localData }: any) => {
    if (!value && value !== 0) {
        return ''
    }

    // 自定义展示方法
    if (typeof field.getDisplayValue === 'function') {
        return field.getDisplayValue({ field, value, localData })
    }

    const concatLabel = str => {
        if (str) {
            if (field.label) {
                return `${field.label}：${str}`
            }
        }

        return str
    }

    // 时间区间
    if (isTimeRage({ value })) {
        return concatLabel([value.startTime, value.endTime].filter(Boolean).join('至'))
    }

    // 模糊、精确匹配选择框
    if (isFuzzyMatchSelect({ field })) {
        if (!value.rightValue) {
            return ''
        }

        return concatLabel(`${value.rightValue}`)
    }

    // 数字区间
    if (isNumberRange({ field })) {
        const formatter = field.props.formatter || (e => e)

        if (value.leftValue && value.rightValue) {
            if (value.leftValue === value.rightValue) {
                return concatLabel(formatter(`${value.leftValue}`))
            }

            return concatLabel([formatter(value.leftValue), formatter(value.rightValue)].join('-'))
        }

        if (value.leftValue) {
            return concatLabel(`大于等于${formatter(value.leftValue)}`)
        }

        if (value.rightValue) {
            return concatLabel(`小于等于${formatter(value.rightValue)}`)
        }

        return ''
    }

    // 单选
    if (isSingleSelect({ field, localData })) {
        const options = field.props?.options || localData?.options || []

        // labelInValue
        if (isObj(value)) {
            return concatLabel(value?.title || value?.label)
        }

        const option = options.find(v => v.value === value)

        return concatLabel(option?.title || option?.label)
    }

    // 多选
    if (isMultipleSelect({ field, localData })) {
        const options = field.props?.options || localData?.options || []

        const transOptions = options.map(v => {
            if (typeof v === 'string' || typeof v === 'number') {
                return {
                    value: v,
                    label: v
                }
            }

            return v
        })

        return concatLabel(
            value
                ?.map(v => (isObj(v) ? v : transOptions.find(v1 => v1.value === v)))
                ?.filter(Boolean)
                ?.map(v => v.title || v.label)
                ?.join('、')
        )
    }

    // 字符串
    if (typeof value === 'string') {
        return concatLabel(value)
    }

    // 字符串
    if (typeof value === 'boolean') {
        return value ? concatLabel('是') : concatLabel('否')
    }

    return ''
}
